import URLS from "@api/constants/urls";
import { IUploadCertificateCancellationSubmitSchema } from "./certificatesAPI.types";
import { handleGlobalPostRequest } from "@api/functions/changeRequests";

const uploadCertificateCancelAPI = (
  data: IUploadCertificateCancellationSubmitSchema
): Promise<{ data: any }> =>
  handleGlobalPostRequest({
    url: `${URLS.CERTIFICATES}${URLS.BULK_CANCEL}`,
    data,
  });
const uploadCertificateDeleteAPI = (
  data: IUploadCertificateCancellationSubmitSchema
): Promise<{ data: any }> =>
  handleGlobalPostRequest({
    url: `${URLS.CERTIFICATES}${URLS.BULK_DELETE}`,
    data,
  });

export { uploadCertificateCancelAPI, uploadCertificateDeleteAPI };
